export default __webpack_public_path__ + "d1fcd4c2ec370ffb79678904de46e5b6.svg";